import React from 'react'

import { SeoMeta } from '../../../../components/SeoMeta'
import { canonicalBaseUrls } from '../../../../constants/figs'

export interface KitPageMetaProps {
  description?: string
  handle: string
  image?: string
  noindex?: boolean
  seoDescription?: string
  seoTitle?: string | undefined | null
  title?: string
  video?: string
}

export const KitPageMeta: React.FC<KitPageMetaProps> = ({
  description,
  handle,
  image,
  noindex,
  seoDescription,
  seoTitle,
  title,
  video,
}) => {
  const canonicalUrl = `${canonicalBaseUrls.kits}${handle}`

  return (
    <SeoMeta
      canonicalUrl={canonicalUrl}
      image={image}
      noindex={noindex}
      video={video}
      description={seoDescription || description}
      imageAlt={description}
      title={seoTitle?.trim().length ? seoTitle : title}
    />
  )
}

export default KitPageMeta
